import React from 'react'
import "./index.css"


const Navbar = () => {
    return (
        <div>
            <div className="app-create-new-bar">
        <p>Create a new account</p>
        {/* <img src={imgres} className="App-logo" alt="logo" /> */}
            </div>
        </div>
    )
}

export default Navbar

